import { useRemainingFemaleReferrals } from "@/tanstack-hooks";
import FlipCountdown from "./FlipCountdown";
import Spinner from "./Spinner";

export default function ReferralSpotCountdown() {
  const { data, error, isLoading } = useRemainingFemaleReferrals();

  if (isLoading) {
    return <Spinner />;
  }

  if (error || !data) {
    return <FlipCountdown start={1} target={0} />;
  }

  const start = data + 7;
  return <FlipCountdown start={start} target={data} />;
}
